// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Data from "./utils/Data.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Store from "./store/Store.bs.js";
import * as Utils from "./utils/Utils.bs.js";
import * as React from "react";
import * as Navbar from "./components/Navbar/Navbar.bs.js";
import * as $$Promise from "@ryyppy/rescript-promise/src/Promise.bs.js";
import * as PostList from "./components/PostList/PostList.bs.js";
import * as SortControls from "./components/SortControls/SortControls.bs.js";

function App(Props) {
  var dispatch = Store.useAppDispatch(undefined);
  React.useEffect((function () {
          $$Promise.$$catch(Promise.resolve(Curry._1(dispatch, /* StartFetch */0)).then(function (param) {
                              return Data.fetchJson(Data.topstories_url);
                            }).then(function (data) {
                            return Utils.decodeWithPromise(data, Data.Codecs.postIds);
                          }).then(function (param) {
                          return param.slice(0, 20);
                        }).then(function (post_ids) {
                        return Utils.mapPromiseAll(post_ids, (function (param) {
                                      return Utils.$dot(Data.fetchJson, Data.single_story_url, param);
                                    }));
                      }).then(function (posts) {
                      return Utils.mapPromiseAll(posts, (function (post) {
                                    return Utils.decodeWithPromise(post, Data.Codecs.post);
                                  }));
                    }).then(function (posts) {
                    return Curry._1(dispatch, {
                                TAG: /* FetchSuccess */0,
                                _0: posts
                              });
                  }), (function (err) {
                  console.log(err);
                  return Promise.resolve(Curry._1(dispatch, /* FetchFailure */1));
                }));
          
        }), []);
  return React.createElement(React.Fragment, undefined, React.createElement(Navbar.make, {}), React.createElement("div", {
                  className: "grid__container grid__container--root"
                }, React.createElement("div", {
                      className: "page__title"
                    }, "Reasonable HackerNews"), React.createElement("div", {
                      className: "sort__container"
                    }, React.createElement("div", {
                          className: "sort__caption"
                        }, "Sort: "), React.createElement(SortControls.make, {
                          className: "sort__item"
                        })), React.createElement(PostList.make, {
                      className: "postlist__container"
                    })));
}

var make = App;

export {
  make ,
  
}
/* Data Not a pure module */
